module.exports = __webpack_public_path__ + "img/20200312104200622.8db2d0e0.jpg";